import { useEffect } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { SourceKey, ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';
import { useFastshiftSelector } from '@/state';

export const useCustomerSelectionPageAnalytics = () => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
	const { data: customerDomains, pending: customerDomainsPending } = useFastshiftSelector(
		(state) => state.customerDomains,
	);

	const { fireScreenEvent, fireTrackEvent } = useFireAnalyticsEvents(identityAttrs);

	// Screen event
	useEffect(() => {
		if (!identityAttrs) return;
		fireScreenEvent({
			name: SourceKey.FASTSHIFT_PORTAL_SELECTION_SCREEN,
		});
	}, [fireScreenEvent, identityAttrs]);

	// Track event
	useEffect(() => {
		if (!identityAttrs || !customerDomains || customerDomainsPending) {
			return;
		}

		fireTrackEvent({
			action: ActionKey.DISPLAYED,
			actionSubject: ActionSubjectKey.SECTION,
			actionSubjectId: ActionSubjectIdKey.SELECTION_PAGE_DETAILS,
			source: sourceKey,
			attributes: {
				customerDomainCount: customerDomains.data.length,
			},
		});
	}, [fireTrackEvent, identityAttrs, customerDomains, customerDomainsPending, sourceKey]);
};
